@for (item of navRoutingItems; track item.iconName) {
  @if (item.link) {
    <div class="iw-mobile-nav-item" [routerLink]="item.link">
      <iw-routing-item
        [link]="item.link"
        [iconName]="item.iconName"
        [iconSize]="24"
        [i18nKey]="item.i18nKey"
      />
    </div>
  }
}
